import React from 'react';
import { Modal, ModalFooter } from '@/components/common';
import { GroupDTO } from '@/models';

interface GroupDeleteModalProps {
  isOpen: boolean;
  group: GroupDTO | null;
  isSaving: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const GroupDeleteModal: React.FC<GroupDeleteModalProps> = ({
  isOpen,
  group,
  isSaving,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackdropClick={false}
      title="Delete Group"
      footer={
        <ModalFooter
          onCancel={onClose}
          onConfirm={onConfirm}
          confirmText="Delete"
          confirmVariant="danger"
          isLoading={isSaving}
        />
      }
    >
      <p>
        Are you sure you want to delete group <strong>{group?.name}</strong>? This
        may affect labs and devices within this group.
      </p>
    </Modal>
  );
};
